import { inject, Injectable } from "@angular/core";
import { select, Store } from "@ngrx/store";

import * as ExcelJS from "exceljs";
import { AppState } from "../../app.state";
import {
  selectAcuerdosHistorico,
  selectAllAcuerdos,
} from "../../states/acuerdos-mrb/selector";
import { AcuerdosService } from "../acuerdos/acuerdos.service";
import {
  catchError,
  finalize,
  firstValueFrom,
  forkJoin,
  map,
  Observable,
  of,
  switchMap,
  take,
} from "rxjs";
import {
  selectTemasUsuario,
  selectTemasUsuarioLectura,
} from "../../states/usuario/selector";
import { selectCatalogoTipoTemas } from "../../states/catalogos/selector";
import * as moment from "moment";
import { LoadingService } from "../../loading/loading.service";

@Injectable({
  providedIn: "root",
})
export class ExcelFilesService {
  constructor(
    private acuerdosService: AcuerdosService,
    private loadingService: LoadingService
  ) {}
  private readonly store: Store<AppState> = inject(Store);
  public readonly selectHistorico: any = this.store.pipe(
    select(selectAllAcuerdos)
  );

  async generateExcel(entries: any) {
    console.log("entries", entries);
   
    
    const entradas = [...entries];
       console.log("entradas", entradas);
    // entradas.sort((a: any, b: any) => b.tsCreation - a.tsCreation);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Entradas");
    const base64Image = await this.getImageAsBase64("assets/images/logo.png");
    const imageId = workbook.addImage({
      base64: base64Image.split(",")[1],
      extension: "png",
    });
    // El logo ocupará las celdas de A1
    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 105, height: 70 },
      editAs: "oneCell",
    });

    // Ajustar la altura de las filas para que se adapten a la imagen
    worksheet.getRow(1).height = 70;
    worksheet.mergeCells("A1:N1");
    // Definir encabezados en la fila A2-N2
    worksheet.getCell("A2").value = "Estatus";
    worksheet.getCell("B2").value = "Fecha de registro";
    worksheet.getCell("C2").value = "Asunto";
    worksheet.getCell("D2").value = "Fecha de entrada";
    worksheet.getCell("E2").value = "Fecha fin";
    worksheet.getCell("F2").value = "Descripción";
    worksheet.getCell("G2").value = "Remitente";
    worksheet.getCell("H2").value = "Modo de entrada";
    worksheet.getCell("I2").value = "Tipo";
    worksheet.getCell("J2").value = "Prioridad";
    worksheet.getCell("K2").value = "Tema";
    worksheet.getCell("L2").value = "Enviado a";
    worksheet.getCell("M2").value = "BB";
    worksheet.getCell("N2").value = "Comentarios";

    // Definir los keys de las columnas con encabezados
    worksheet.columns = [
      { key: "estatus", width: 15 },
      { key: "fecha_registro", width: 15 },
      { key: "asunto", width: 50 },
      { key: "fecha_de_entrada", width: 15 },
      { key: "fecha_fin", width: 15 },
      { key: "descripcion", width: 50 },
      { key: "remitente", width: 50 },
      { key: "modo_de_entrada", width: 30 },
      { key: "tipo", width: 20 },
      { key: "prioridad", width: 20 },
      { key: "tema", width: 50 },
      { key: "enviado_a", width: 50 },
      { key: "bb" },
      { key: "comentarios", width: 50 },
    ];

    // Aplicar estilo a los encabezados
    worksheet.getCell("A2").font = { bold: true };
    worksheet.getCell("B2").font = { bold: true };
    worksheet.getCell("C2").font = { bold: true };
    worksheet.getCell("D2").font = { bold: true };
    worksheet.getCell("E2").font = { bold: true };
    worksheet.getCell("F2").font = { bold: true };
    worksheet.getCell("G2").font = { bold: true };
    worksheet.getCell("H2").font = { bold: true };
    worksheet.getCell("I2").font = { bold: true };
    worksheet.getCell("J2").font = { bold: true };
    worksheet.getCell("K2").font = { bold: true };
    worksheet.getCell("L2").font = { bold: true };
    worksheet.getCell("M2").font = { bold: true };
    worksheet.getCell("N2").font = { bold: true };

    // Agregar filas de datos comenzando desde la fila 2
    for (const entrada of entradas) {
      const row = worksheet.addRow({
        estatus: this.getStatus(entrada.estatus_descripcion, entrada.end),
        fecha_registro: this.getFecha(entrada.start),
        asunto: entrada.asunto ?? "",
        fecha_de_entrada: entrada.fechaInicio
          ? this.getFecha(entrada.fechaInicio)
          : entrada.fechaEnt,
        fecha_fin: this.getFecha(entrada.fechaFin) ?? "",
        descripcion: this.decodeHtml(entrada.descripcion) ?? "",
        remitente: this.getRemitente(entrada.remitente, entrada),
        modo_de_entrada: entrada.modo_entrada_descripcion ?? "",
        tipo: entrada.tipo_descripcion ?? "",
        prioridad: entrada.prioridad_descripcion ?? "",
        tema: entrada.tema_descripcion ?? "",
        enviado_a: entrada.delegado_descripcion ?? "",
        bb: entrada.bb_enviado_descripcion ?? "",
        comentarios: this.getComentarios(entrada.comentarios),
      });

      // Ajuste de alineación para las celdas 1 a 14
      for (let colIndex = 1; colIndex <= 14; colIndex++) {
        row.getCell(colIndex).alignment = {
          wrapText: true,
          vertical: "top",
          horizontal: "left",
        };
      }
    }

    // Aplicar bordes a todas las celdas
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
        // Verificamos si la celda es la primera (columna 1, fila 1)
        console.log("rowNumber", rowNumber);
        console.log("colNumber", colNumber);
        if (rowNumber === 1) {
          return;
        }

        cell.border = {
          top: { style: "medium", color: { argb: "FF000000" } },
          left: { style: "medium", color: { argb: "FF000000" } },
          bottom: { style: "medium", color: { argb: "FF000000" } },
          right: { style: "medium", color: { argb: "FF000000" } },
        };
      });
    });

    // Generar el archivo y crear un blob
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Descargar el archivo
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Export.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  }

  private async getImageAsBase64(imageUrl: string): Promise<string> {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result as string;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  getFecha(fecha: string): string {
    if (fecha && fecha.includes("T")) {
      return fecha.split("T")[0];
    }
    return fecha ?? "";
  }
  getStatus(status: string, fecha: string): string {
    console.log("status", status);
    
     console.log("fecha", fecha);
    
    if (status !== "Terminado") {
        const endDate = new Date(fecha);
        const now = new Date();

      const isVencido = now > endDate;
      return isVencido ? "Vencido" : "En proceso";
    } else {
      return status;
    }
  }

  getRemitente(remitente: string, entrada: any): string {
    const sSalida: string[] = [];
    if (remitente === "-Kd1EX0gNjABLH0Yj0fN") {
      const aNombres: string[] = [];
      if (typeof entrada.remitente_enviado_descripcion == "object") {
        for (let n = 0; n < entrada.remitente_enviado_descripcion.length; n++) {
          aNombres.push(entrada.remitente_enviado_descripcion[n].split("-")[0]);
        }
      }
      sSalida.push(aNombres.join(", "));
    } else {
      if (typeof entrada.remitente_descripcion === "undefined") {
        sSalida.push(remitente);
      } else {
        sSalida.push(entrada.remitente_descripcion.split("-")[0]);
      }
    }
    return `${sSalida.join("")}`;
  }

  getComentarios(comentarios: any[]): string {
    if (comentarios.length === 0) {
      return "";
    }

    return comentarios
      .map((comentario) => {
        const fecha = comentario.fecha ? this.getFecha(comentario.fecha) : "";
        const usuarios = comentario.usuario ? comentario.usuario : "";
        const descripcion = comentario.descripcion
          ? comentario.descripcion
          : "";

        return [fecha, usuarios, descripcion]
          .filter((field) => field)
          .join(",");
      })
      .join(" | ");
  }

  downloadHistorico(): Observable<any[]> {
    console.log("downloadHistorico service ...");

    // Obtén los datos de los selectores como observables
    const acuerdos$ = this.store.pipe(select(selectAcuerdosHistorico), take(1));
    const temas$ = this.store.pipe(select(selectTemasUsuario), take(1));
    const tipoTemas$ = this.store.pipe(
      select(selectCatalogoTipoTemas),
      take(1)
    );

    // Combina los observables usando forkJoin
    return forkJoin([acuerdos$, temas$, tipoTemas$]).pipe(
      switchMap(([listAcuerdos, lisTemasLectura, tipoTemas]) => {
        // Clonar los datos si es necesario
        console.log("tipoTemas", tipoTemas);

        const acuerdos = [...listAcuerdos];
        const temasUsuarioLectura = [...Object.keys(lisTemasLectura)];

        console.log("acuerdos:", acuerdos);
        console.log("temas :", temasUsuarioLectura);

        // Crear una lista de observables para obtener detalles de acuerdos
        const acuerdosObservables$ = acuerdos.map((acuerdo: any) =>
          this.acuerdosService.detalleAcuerdo(acuerdo.idFE).pipe(
            catchError((error) => {
              console.error("Error en detalleAcuerdo:", error);
              return of({ error: true, temas: [] });
            }),
            map((detalle: any) => {
              if (detalle.error) {
                return null;
              }
              let temas = detalle.temas.filter(
                (tema: any) => tema.edoTema !== 2 && tema.edoTema !== 3
              );

              let temasPrint = temas.map((value: any) => {
                let verTema = this.getPermisoConfidencial(
                  value.categorizacion,
                  temasUsuarioLectura
                );
                console.log("verTema");

                let tipoTema = this.getTipo(value.tipoTema, tipoTemas);
                if (!verTema) {
                  value.nombreTema = "Tema Confidencial.";
                  value.descripcionTema = "";
                  tipoTema = "";
                }

                value.tipoTema = tipoTema;
                let { entradas } = this.getPermisosEntradaPrint(
                  value.entradas,
                  verTema,
                  temasUsuarioLectura
                );
                value.entradas = entradas;
                value.indicacionesAB = value.indicacionesAB.map((iAB: any) => ({
                  ...iAB,
                  fechaIndicacion: "",
                }));

                return value;
              });

              if (temasPrint.length) {
                let formatTema = temasPrint.map((t: any) => ({
                  tipoTema: t.tipoTema,
                  indiceTema: t.indiceTema,
                  nombreTema: t.nombreTema,
                  descripcionTema: this.stripHtml(
                    `<div>${t.descripcionTema_html}</div>`
                  ),
                  entradas: t.entradas,
                  indicacionesAB: t.indicacionesAB,
                }));

                const fechaAcuerdo = this.convertirFecha(acuerdo.fechaAcuerdo);
                return {
                  fechaAcuerdo,
                  temas: formatTema,
                };
              }

              return null;
            })
          )
        );

        return forkJoin(acuerdosObservables$).pipe(
          map((resultados) =>
            resultados.filter((resultado) => resultado !== null)
          )
        );
      })
    );
  }

  getPermisoConfidencial(categorizacionTema: string, temasLectura: any[]) {
    return temasLectura.indexOf(categorizacionTema) !== -1;
  }
  getTipo(tipo: number, tipoTemas: any): string {
    console.log("tipo", tipo);
    console.log("tipoTemas", tipoTemas);

    const tema = tipoTemas.find((item: any) => item.id === tipo);
    return tema ? tema.descripcion : "";
  }
  getPermisosEntradaPrint(entradas: any, verTema: boolean, temasLectura: any) {
    if (entradas.length) {
      //debugger;
      for (let i = 0; i < entradas.length; i++) {
        //debugger;
        let entrada = entradas[i];

        entrada.puedeVer = this.getPermisoConfidencial(
          entrada.idCategorizacion,
          temasLectura
        );
        if (!entrada.puedeVer || !verTema) {
          entrada.nombreEntrada = "Material Confidencial.";
        } else {
          entrada.nombreEntrada = entrada.nombreEntradaCompleto;
        }

        if (verTema && entrada.entregables) {
          let entregables = [];

          for (let k = 0; k < entrada.entregables.length; k++) {
            let value = entrada.entregables[k];

            if (
              !value.nombreEntregable ||
              value.nombreEntregable.trim() === ""
            ) {
              value.nombreEntregable = "Adjuntar Archivo.";
            }

            if (!entrada.puedeVer) {
              value.nombreEntregable = "";
            }

            // if(value.edoEntregable !== 2 && value.edoEntregable !== 3){
            //     return value;
            // }
            if (entrada.puedeVer) {
              entregables.push({
                nombreEntregable: value.nombreEntregable,
              });
            }
          }

          entrada.entregables = entregables;
        }

        entradas[i] = {
          nombreEntrada: entrada.nombreEntrada,
          nombreEntradaCompleto: entrada.nombreEntradaCompleto,
          entregables: entrada.entregables,
        };
      }
    }

    return { entradas };
  }

  exportHistorico() {
    this.loadingService.show();
    this.downloadHistorico().subscribe((acuerdos) => {
      if (acuerdos.length > 0) {
        this.acuerdosService.exportAcuerdos(acuerdos).subscribe((blob) => {
          console.log("file", blob);
          this.loadingService.hide();
          this.download(blob, acuerdos);
        });
      } else {
        this.loadingService.hide();
        alert("hubo un error");
      }
    });
  }

  convertirFecha(dateString: string): string {
    const [year, month, day] = dateString.split("T")[0].split("-");
    return `${day}-${month}-${year}`;
  }

  stripHtml(html: string) {
    var temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = html;
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
  }

  download(data: BlobPart, acuerdos: any[]) {
    var blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    let fileName = `${acuerdos[0].fechaAcuerdo}.xlsx`;
    if (acuerdos.length > 1) {
      fileName = "historico.xlsx";
    }
    var link = document.createElement("a");

    link.id = `${acuerdos[0].fechaAcuerdo}`;
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    // Revocar el objeto URL y eliminar el elemento por clase
    setTimeout(() => {
      window.URL.revokeObjectURL(link.href);
      const elements = document.getElementById(`${acuerdos[0].fechaAcuerdo}`);
      elements?.remove();
    }, 2000);
  }

  decodeHtml(html: string) {
    if (!html) {
      return ""
    }
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value.replace(/[\n\r]+/g, " ").trim();
  }
}
